import Vue from 'vue';
import { setToken, setAcceptLanguage, setCountryCode } from '@/plugins/http';

import types from './mutation-types';

function subscribe(store) {
  store.subscribe((mutation, { Auth }) => {
    switch (mutation.type) {
      case types.SET_TOKEN: {
        setToken(Auth.token);
        break;
      }

      case types.SET_USER: {
        Vue.$ga.set('userId', Auth.user.user_id);
        Vue.$ga.set('dimension1', Auth.user.role);
        Vue.$ga.set('dimension2', Auth.user.grade_id);
        Vue.$ga.set('dimension3', Auth.user.school_id);
        Vue.$ga.set('dimension4', Auth.user.zipcode);
        setAcceptLanguage(Auth.user.language);
        setCountryCode(Auth.user.country_code);
        break;
      }

      default: {
        break;
      }
    }
  });
}

export default (store) => {
  subscribe(store);
};



// WEBPACK FOOTER //
// ./src/app/auth/store/plugin.js